import { Tab } from 'bootstrap';

export default class TabsManager {
    constructor() {
        this.initTabs();
    }

    initTabs() {
        const urlParams = new URLSearchParams(window.location.search);
        const tabId = urlParams.get('tab'); // Récupère l'ID du produit depuis l'URL

        if (tabId) {
            const tabButton = document.querySelector(`#tab-${tabId}`);
            if (tabButton) {
                new Tab(tabButton).show(); // Utilise Tab de l'importation pour montrer l'onglet
            } else {
                console.log("Onglet correspondant à l'ID " + tabId + " non trouvé.");
            }
        }
    }
}